import * as TYPES from './type-actions';

export const MAP_MARGIN_BOTTOM_BUFFER = 30;

/**
 * 地图模式：普通模式，显示运营区域，可拖拽地图选择站点
 * @type {string}
 */
export const MAP_MODE_NORMAL = 'normal';
/**
 * 地图模式：运行模式，不显示运营区域和站点，不可拖拽选择站点，展示用户上下车站和车辆位置
 * @type {string}
 */
export const MAP_MODE_RUNNING = 'running';

/**
 * 地图缩放模式：A模式，根据区域、上车站、下车站缩放
 * @type {string}
 */
export const MAP_FIT_VIEW_MODE_A = 'area_on_off';

/**
 * 地图缩放模式：B模式，根据用户位置缩放
 * @type {string}
 */
export const MAP_FIT_VIEW_MODE_B = 'user';

/**
 * 地图缩放模式：C模式，根据运行中的上、下车站和车辆缩放
 * @type {string}
 */
export const MAP_FIT_VIEW_MODE_C = 'running_on_off_bus';

/**
 * 地图缩放模式：D模式，根据上车站缩放
 * @type {string}
 */
export const MAP_FIT_VIEW_MODE_D = 'on';

/**
 * 地图缩放模式：E模式，根据下车站缩放
 * @type {string}
 */
export const MAP_FIT_VIEW_MODE_E = 'off';

export default {
	state: {
		// 1. 地图属性
		map: {
			instance: null, // 地图实例
			margins: [40, 40, 0, 40], // 地图上、右、下、左阻碍物的占位，单位：px
			mode: MAP_MODE_NORMAL, // 地图模式
			fitViewMode: '', // 缩放模式
			hideUserPosCtrl: false, // 隐藏用户位置控件
			fitViewToUserPos: false, // 聚焦到用户位置
			removeMarkerLabel: false, // 移除marker的label2
		},
		// 2. 数据源
		dataSource: {
			areas: [], // 运营区域列表
			stops: [], // 站点列表
			userPos: null, // 用户位置
      userPosInfo: null, // 用户位置信息（不止坐标）
			onStop: null, // 上车站
			offStop: null, // 下车站
			busPos: null, // 车辆位置
			areaCenterPos: null, // 区域中心点
			runningOnStop: null, // 运行中的上车站
			runningOffStop: null, // 运行中的下车站
      runningRoute: null, // 运行中的线路
      runningNaviStop: null, // 运行中的经停点
		},
		// 3. 覆盖物
		overlays: {
			areaPolygons: [], // 运营区域polygon列表
			stopMarkers: [], // 站点marker列表
			userMarker: null, // 用户marker
			onStopMarker: null, // 上车站marker
			onStopLabel: null, // 上车站气泡
			offStopMarker: null, // 下车站marker
			offStopLabel: null, // 下车站气泡
			busMarker: null, // 车辆marker
			runningOnStopMarker: null, // 运行中的上车站marker
			runningOffStopMarker: null, // 运行中的下车站marker
			runningOnStopLabel: null, // 运行中的上车站label
			runningOffStopLabel: null, // 运行中的下车站label
			posingLabel: null, // 定位中动效label
      runningPolyline: null, // 运行中的脊线
      runningNaviStopMarker: null, // 运行中经停点marker
		},
		// 4. 状态
		state: {
			mapVisible: false, // 地图是否显示，优先级高于路由配置中的mapVisible
			poiSearching: false, // 正在检索poi
			userPosLocating: false, // 正在定位用户位置
			onStopDraggable: false, // 拖拽地图是否可以选择上车站
			offStopDraggable: false, // 拖拽地图是否可以选择下车站
			renderFlag: 0, // 递增状态值，用户提示地图重新渲染
			dragNearestOffStop: null, // 拖拽地图选取的最近下车站
			draggingOn: false, // 上车站是否在拖拽中
			draggingOff: false, // 下车站是否在拖拽中
		}
	},
	getters: {
		mapMargins: state => state.map.margins,
		mapMarginsBottom: state => state.map.margins ? state.map.margins[2] : 0,
		mapInstance: state => state.map.instance,
		mapMode: state => state.map.mode,
		mapFitViewMode: state => state.map.fitViewMode,
		dataSource: state => {
			let {
				areas,
				stops,
				userPos,
				onStop,
				offStop,
				busPos,
				runningOnStop,
				runningOffStop
			} = state.dataSource;
			let mode = state.map.mode;
			let isModeRunning = mode === MAP_MODE_RUNNING;
			areas = isModeRunning ? [] : areas;
			stops = isModeRunning ? [] : stops;
			busPos = isModeRunning ? busPos : null;
			onStop = isModeRunning ? null : onStop;
			offStop = isModeRunning ? null : offStop;
			runningOnStop = isModeRunning ? runningOnStop : null;
			runningOffStop = isModeRunning ? runningOffStop : null;
			return [
				...(areas.reduce((prev, area) => [...prev, ...area], [])),
				...(stops.map(stop => [stop.lng, stop.lat])),
				userPos ? [userPos] : null,
				onStop ? [onStop.lng, onStop.lat] : null,
				offStop ? [offStop.lng, offStop.lat] : null,
				busPos ? [busPos.lng, busPos.lat] : null,
				runningOnStop ? [runningOnStop.lng, runningOnStop.lat] : null,
				runningOffStop ? [runningOffStop.lng, runningOffStop.lat] : null
			];
		},
		dataAreas: state => state.dataSource.areas,
		dataStops: state => state.dataSource.stops,
		dataUserPos: state => state.dataSource.userPos,
		dataUserPosInfo: state => state.dataSource.userPosInfo,
		dataOnStop: state => state.dataSource.onStop,
		dataOffStop: state => state.dataSource.offStop,
		dataBusPos: state => state.dataSource.busPos,
		dataAreaCenterPos: state => state.dataSource.areaCenterPos,
		dataRunningOnStop: state => state.dataSource.runningOnStop,
		dataRunningOffStop: state => state.dataSource.runningOffStop,
    dataRunningRoute: state => state.dataSource.runningRoute,
    dataRunningNaviStop: state => state.dataSource.runningNaviStop,
		overlays: state => {
			const {
				areaPolygons,
				stopMarkers,
				userMarker,
				onStopMarker,
				onStopLabel,
				offStopMarker,
				offStopLabel,
				busMarker
			} = state.overlays;
			return [
				...areaPolygons,
				...stopMarkers,
				userMarker,
				onStopMarker,
				onStopLabel,
				offStopMarker,
				offStopLabel,
				busMarker
			].filter(p => !!p);
		},
		overlayAreaPolygons: state => state.overlays.areaPolygons,
		overlayStopMarkers: state => state.overlays.stopMarkers,
		overlayUserMarker: state => state.overlays.userMarker,
		overlayOnStopMarker: state => state.overlays.onStopMarker,
		overlayOnStopLabel: state => state.overlays.onStopLabel,
		overlayOffStopMarker: state => state.overlays.offStopMarker,
		overlayOffStopLabel: state => state.overlays.offStopLabel,
		overlayBusMarker: state => state.overlays.busMarker,
		overlayRunningOnStopMarker: state => state.overlays.runningOnStopMarker,
		overlayRunningOffStopMarker: state => state.overlays.runningOffStopMarker,
		overlayRunningOnStopLabel: state => state.overlays.runningOnStopLabel,
		overlayRunningOffStopLabel: state => state.overlays.runningOffStopLabel,
		overlayPosingLabel: state => state.overlays.posingLabel,
    overlayRunningNaviStopMarker: state => state.overlays.runningNaviStopMarker,
    overlayRunningPolyline: state => state.overlays.runningPolyline,
		stateMapVisible: state => state.state.mapVisible,
		statePoiSearching: state => state.state.poiSearching,
		stateUserPosLocating: state => state.state.userPosLocating,
		stateOnStopDraggable: state => state.state.onStopDraggable,
		stateOffStopDraggable: state => state.state.offStopDraggable,
		stateRenderFlag: state => state.state.renderFlag,
		stateDragNearestOffStop: state => state.state.dragNearestOffStop,
		stateDraggingOn: state => state.state.draggingOn,
		stateDraggingOff: state => state.state.draggingOff,
		fitViewToUserPos: state => state.map.fitViewToUserPos,
		hideUserPosCtrl: state => state.map.hideUserPosCtrl,
		removeMarkerLabel: state => state.map.removeMarkerLabel
	},
	mutations: {
		// 1. 地图属性
		[TYPES.MAP__SET_MAP_MARGINS](state, payload) {
			state.map.margins = payload;
		},
		[TYPES.MAP__SET_MAP_MARGIN_BOTTOM](state, payload) {
			let [top, right, bottom, left] = state.map.margins;
			bottom = payload + MAP_MARGIN_BOTTOM_BUFFER;
			state.map.margins = [top, right, bottom, left];
		},
		[TYPES.MAP__SET_MAP_INSTANCE](state, payload) {
			state.map.instance = payload;
		},
		[TYPES.MAP__SET_MAP_MODE](state, payload) {
			state.map.mode = payload;
		},
		[TYPES.MAP__SET_FIT_VIEW_MODE](state, payload) {
			state.map.fitViewMode = payload;
		},
		// 2. 数据源
		[TYPES.MAP__SET_MAP_DATA_AREAS](state, payload) {
			state.dataSource.areas = payload;
		},
		[TYPES.MAP__ADD_MAP_DATA_AREA](state, payload) {
			state.dataSource.areas = state.dataSource.areas.concat(payload);
		},
		[TYPES.MAP__REMOVE_MAP_DATA_AREA](state, index) {
			let prev = state.dataSource.areas.slice(0, index);
			let next = state.dataSource.areas.slice(index+1, state.dataSource.areas.length);
			state.dataSource.areas = [...prev, ...next];
		},
		[TYPES.MAP__SET_MAP_DATA_STOPS](state, payload) {
			state.dataSource.stops = payload;
		},
		[TYPES.MAP__SET_MAP_USER_POS](state, payload) {
			state.dataSource.userPos = payload;
		},
		[TYPES.MAP__SET_MAP_USER_POS2](state, payload) {
			state.dataSource.userPosInfo = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_ON_STOP](state, payload) {
			state.dataSource.onStop = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_OFF_STOP](state, payload) {
			state.dataSource.offStop = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_AREA_CENTER_POS](state, payload) {
			state.dataSource.areaCenterPos = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_BUS_POS](state, payload) {
			state.dataSource.busPos = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_ON_STOP](state, payload) {
			state.dataSource.runningOnStop = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_OFF_STOP](state, payload) {
			state.dataSource.runningOffStop = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_ROUTE](state, payload) {
			state.dataSource.runningRoute = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP](state, payload) {
			state.dataSource.runningNaviStop = payload;
		},
		// 3. 覆盖物
		[TYPES.MAP__SET_OVERLAY_AREA_POLYGONS](state, payload) {
			state.overlays.areaPolygons = payload;
		},
		[TYPES.MAP__SET_OVERLAY_STOP_MARKERS](state, payload) {
			state.overlays.stopMarkers = payload;
		},
		[TYPES.MAP__SET_OVERLAY_ON_STOP_MARKER](state, payload) {
			state.overlays.onStopMarker = payload;
		},
		[TYPES.MAP__SET_OVERLAY_OFF_STOP_MARKER](state, payload) {
			state.overlays.offStopMarker = payload;
		},
		[TYPES.MAP__SET_OVERLAY_ON_STOP_LABEL](state, payload) {
			state.overlays.onStopLabel = payload;
		},
		[TYPES.MAP__SET_OVERLAY_OFF_STOP_LABEL](state, payload) {
			state.overlays.offStopLabel = payload;
		},
		[TYPES.MAP__SET_OVERLAY_USER_POS_MARKER](state, payload) {
			state.overlays.userMarker = payload;
		},
		[TYPES.MAP__SET_OVERLAY_BUS_MARKER](state, payload) {
			state.overlays.busMarker = payload;
		},
		[TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_MARKER](state, payload) {
			state.overlays.runningOnStopMarker = payload;
		},
		[TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_MARKER](state, payload) {
			state.overlays.runningOffStopMarker = payload;
		},
		[TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_LABEL](state, payload) {
			state.overlays.runningOnStopLabel = payload;
		},
		[TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_LABEL](state, payload) {
			state.overlays.runningOffStopLabel = payload;
		},
		[TYPES.MAP__SET_OVERLAY_POSING_LABEL](state, payload) {
			state.overlays.posingLabel = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_POLYLINE](state, payload) {
			state.overlays.runningPolyline = payload;
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP_MARKER](state, payload) {
			state.overlays.runningNaviStopMarker = payload;
		},
		// 4. 状态
		[TYPES.MAP__SET_STATE_MAP_VISIBLE](state, payload) {
			state.state.mapVisible = payload;
		},
		[TYPES.MAP__SET_STATE_POI_SEARCHING](state, payload) {
			state.state.poiSearching = payload;
		},
		[TYPES.MAP__SET_STATE_ON_STOP_DRAGGABLE](state, payload) {
			state.state.onStopDraggable = payload;
		},
		[TYPES.MAP__SET_STATE_OFF_STOP_DRAGGABLE](state, payload) {
			state.state.offStopDraggable = payload;
		},
		[TYPES.MAP__SET_STATE_RENDER_FLAG](state) {
			state.state.renderFlag += 1;
		},
		[TYPES.MAP__SET_STATE_DRAG_NEAREST_OFF_STOP](state, payload) {
			state.state.dragNearestOffStop = payload;
		},
		[TYPES.MAP__SET_STATE_DRAGGING_ON](state, payload) {
			state.state.draggingOn = payload;
		},
		[TYPES.MAP__SET_STATE_DRAGGING_OFF](state, payload) {
			state.state.draggingOff = payload;
		},
		setFitViewToUserPos(state, payload) {
			state.map.fitViewToUserPos = payload
		},
		setHideUserPosCtrl(state, payload) {
			state.map.hideUserPosCtrl = payload
		},
		setRemoveMarkerLabel(state, payload) {
			state.map.removeMarkerLabel = payload
		}
	},
	actions: {
		// 1. 地图属性
		[TYPES.MAP__SET_MAP_MARGINS]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_MARGINS, payload);
		},
		[TYPES.MAP__SET_MAP_MARGIN_BOTTOM]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_MARGIN_BOTTOM, payload);
		},
		[TYPES.MAP__SET_MAP_INSTANCE]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_INSTANCE, payload);
		},
		[TYPES.MAP__SET_MAP_MODE]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_MODE, payload);
		},
		[TYPES.MAP__SET_FIT_VIEW_MODE]({commit}, payload) {
			commit(TYPES.MAP__SET_FIT_VIEW_MODE, payload);
		},
		// 2. 数据源
		[TYPES.MAP__SET_MAP_DATA_AREAS]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_AREAS, payload);
		},
		[TYPES.MAP__ADD_MAP_DATA_AREA]({commit}, payload) {
			commit(TYPES.MAP__ADD_MAP_DATA_AREA, payload);
		},
		[TYPES.MAP__REMOVE_MAP_DATA_AREA]({commit}, payload) {
			commit(TYPES.MAP__REMOVE_MAP_DATA_AREA, payload);
		},
		[TYPES.MAP__SET_MAP_DATA_STOPS]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_STOPS, payload);
		},
		[TYPES.MAP__SET_MAP_USER_POS]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_USER_POS, payload);
		},
    [TYPES.MAP__SET_MAP_USER_POS2]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_USER_POS2, payload)
		},
		[TYPES.MAP__SET_MAP_DATA_ON_STOP]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_ON_STOP, payload);
		},
		[TYPES.MAP__SET_MAP_DATA_OFF_STOP]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_OFF_STOP, payload);
		},
		[TYPES.MAP__SET_MAP_DATA_AREA_CENTER_POS]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_AREA_CENTER_POS, payload);
		},
		[TYPES.MAP__SET_MAP_DATA_BUS_POS]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_BUS_POS, payload);
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_ON_STOP]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_RUNNING_ON_STOP, payload);
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_OFF_STOP]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_RUNNING_OFF_STOP, payload);
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_ROUTE]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_RUNNING_ROUTE, payload)
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP, payload)
		},
		// 3. 覆盖物
		[TYPES.MAP__SET_OVERLAY_AREA_POLYGONS]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_AREA_POLYGONS, payload);
		},
		[TYPES.MAP__SET_OVERLAY_STOP_MARKERS]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_STOP_MARKERS, payload);
		},
		[TYPES.MAP__SET_OVERLAY_ON_STOP_MARKER]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_ON_STOP_MARKER, payload);
		},
		[TYPES.MAP__SET_OVERLAY_OFF_STOP_MARKER]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_OFF_STOP_MARKER, payload);
		},
		[TYPES.MAP__SET_OVERLAY_ON_STOP_LABEL]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_ON_STOP_LABEL, payload);
		},
		[TYPES.MAP__SET_OVERLAY_OFF_STOP_LABEL]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_OFF_STOP_LABEL, payload);
		},
		[TYPES.MAP__SET_OVERLAY_USER_POS_MARKER]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_USER_POS_MARKER, payload);
		},
		[TYPES.MAP__SET_OVERLAY_BUS_MARKER]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_BUS_MARKER, payload);
		},
		[TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_MARKER]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_MARKER, payload);
		},
		[TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_MARKER]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_MARKER, payload);
		},
		[TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_LABEL]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_RUNNING_ON_STOP_LABEL, payload);
		},
		[TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_LABEL]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_RUNNING_OFF_STOP_LABEL, payload);
		},
		[TYPES.MAP__SET_OVERLAY_POSING_LABEL]({commit}, payload) {
			commit(TYPES.MAP__SET_OVERLAY_POSING_LABEL, payload);
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_POLYLINE]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_RUNNING_POLYLINE, payload)
		},
		[TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP_MARKER]({commit}, payload) {
			commit(TYPES.MAP__SET_MAP_DATA_RUNNING_NAVI_STOP_MARKER, payload)
		},
		// 4. 状态
		[TYPES.MAP__SET_STATE_MAP_VISIBLE]({commit}, payload) {
			commit(TYPES.MAP__SET_STATE_MAP_VISIBLE, payload);
		},
		[TYPES.MAP__SET_STATE_POI_SEARCHING]({commit}, payload) {
			commit(TYPES.MAP__SET_STATE_POI_SEARCHING, payload);
		},
		[TYPES.MAP__SET_STATE_ON_STOP_DRAGGABLE]({commit}, payload) {
			commit(TYPES.MAP__SET_STATE_ON_STOP_DRAGGABLE, payload);
		},
		[TYPES.MAP__SET_STATE_OFF_STOP_DRAGGABLE]({commit}, payload) {
			commit(TYPES.MAP__SET_STATE_OFF_STOP_DRAGGABLE, payload);
		},
		[TYPES.MAP__SET_STATE_RENDER_FLAG]({commit}) {
			commit(TYPES.MAP__SET_STATE_RENDER_FLAG);
		},
		[TYPES.MAP__SET_STATE_DRAG_NEAREST_OFF_STOP]({commit}, payload) {
			commit(TYPES.MAP__SET_STATE_DRAG_NEAREST_OFF_STOP, payload);
		},
		[TYPES.MAP__SET_STATE_DRAGGING_ON]({commit}, payload) {
			commit(TYPES.MAP__SET_STATE_DRAGGING_ON, payload);
		},
		[TYPES.MAP__SET_STATE_DRAGGING_OFF]({commit}, payload) {
			commit(TYPES.MAP__SET_STATE_DRAGGING_OFF, payload);
		}
	}
};
